module.exports = __webpack_public_path__ + "static/media/pimpmyride.f189282d.jpg";